import React, { useState } from 'react';
import { SearchIcon, FilterIcon, PlusIcon, ChevronLeftIcon, ChevronRightIcon, XIcon, UserIcon, PhoneIcon, MailIcon, CalendarIcon, MapPinIcon, BadgeIcon, MoreVerticalIcon } from 'lucide-react';
const MemberManagementScreen = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  // Sample member data
  const members = [{
    id: 1,
    name: 'Ahmed Ali',
    itsNumber: 'ITS12345',
    rank: 'Guard Level 2',
    joinDate: '2020-05-15',
    phone: '+91 98765 43210',
    email: 'ahmed.ali@example.com',
    address: '123 Main Street, Dahod',
    status: 'Active',
    profileImage: 'https://randomuser.me/api/portraits/men/1.jpg'
  }, {
    id: 2,
    name: 'Murtaza Husain',
    itsNumber: 'ITS23456',
    rank: 'Guard Level 1',
    joinDate: '2021-03-10',
    phone: '+91 87654 32109',
    email: 'murtaza.h@example.com',
    address: '456 Park Avenue, Dahod',
    status: 'Active',
    profileImage: 'https://randomuser.me/api/portraits/men/2.jpg'
  }, {
    id: 3,
    name: 'Yusuf Najmuddin',
    itsNumber: 'ITS34567',
    rank: 'Senior Guard',
    joinDate: '2018-11-22',
    phone: '+91 76543 21098',
    email: 'yusuf.n@example.com',
    address: '789 Oak Lane, Dahod',
    status: 'On Leave',
    profileImage: 'https://randomuser.me/api/portraits/men/3.jpg'
  }, {
    id: 4,
    name: 'Taher Saifuddin',
    itsNumber: 'ITS45678',
    rank: 'Guard Level 3',
    joinDate: '2019-07-30',
    phone: '+91 65432 10987',
    email: 'taher.s@example.com',
    address: '101 Elm Street, Dahod',
    status: 'Active',
    profileImage: 'https://randomuser.me/api/portraits/men/4.jpg'
  }, {
    id: 5,
    name: 'Qasim Hakimuddin',
    itsNumber: 'ITS56789',
    rank: 'Guard Level 1',
    joinDate: '2022-01-15',
    phone: '+91 54321 09876',
    email: 'qasim.h@example.com',
    address: '202 Pine Road, Dahod',
    status: 'Inactive',
    profileImage: 'https://randomuser.me/api/portraits/men/5.jpg'
  }, {
    id: 6,
    name: 'Hussain Burhanuddin',
    itsNumber: 'ITS67890',
    rank: 'Senior Guard',
    joinDate: '2017-09-05',
    phone: '+91 43210 98765',
    email: 'hussain.b@example.com',
    address: '303 Cedar Avenue, Dahod',
    status: 'Active',
    profileImage: 'https://randomuser.me/api/portraits/men/6.jpg'
  }, {
    id: 7,
    name: 'Ali Akbar',
    itsNumber: 'ITS78901',
    rank: 'Guard Level 2',
    joinDate: '2020-12-10',
    phone: '+91 32109 87654',
    email: 'ali.a@example.com',
    address: '404 Maple Street, Dahod',
    status: 'Active',
    profileImage: 'https://randomuser.me/api/portraits/men/7.jpg'
  }, {
    id: 8,
    name: 'Mohammed Qutbuddin',
    itsNumber: 'ITS89012',
    rank: 'Guard Level 3',
    joinDate: '2019-04-22',
    phone: '+91 21098 76543',
    email: 'mohammed.q@example.com',
    address: '505 Birch Lane, Dahod',
    status: 'On Leave',
    profileImage: 'https://randomuser.me/api/portraits/men/8.jpg'
  }];
  // Function to open the view modal with selected member
  const handleView = member => {
    setSelectedMember(member);
    setShowViewModal(true);
  };
  // Function to open the edit modal with selected member
  const handleEdit = member => {
    setSelectedMember(member);
    setShowAddModal(true);
  };
  // Function to open an empty add modal
  const handleAdd = () => {
    setSelectedMember(null);
    setShowAddModal(true);
  };
  return <div className="space-y-6" data-id="element-488">
      <div className="flex justify-between items-center" data-id="element-489">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-490">Member Management</h1>
        <button onClick={handleAdd} className="bg-blue-800 text-white px-4 py-2 rounded-md flex items-center" data-id="element-491">
          <PlusIcon size={18} className="mr-1" data-id="element-492" />
          Add New Member
        </button>
      </div>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-493">
        <div className="bg-white rounded-lg shadow p-6" data-id="element-494">
          <div className="text-sm font-medium text-gray-500" data-id="element-495">Total Members</div>
          <div className="text-2xl font-bold mt-1" data-id="element-496">140</div>
          <div className="text-xs text-green-600 mt-1" data-id="element-497">+5 this month</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-498">
          <div className="text-sm font-medium text-gray-500" data-id="element-499">
            Active Members
          </div>
          <div className="text-2xl font-bold mt-1" data-id="element-500">120</div>
          <div className="text-xs text-gray-500 mt-1" data-id="element-501">86% of total</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-502">
          <div className="text-sm font-medium text-gray-500" data-id="element-503">On Leave</div>
          <div className="text-2xl font-bold mt-1" data-id="element-504">15</div>
          <div className="text-xs text-yellow-600 mt-1" data-id="element-505">11% of total</div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-506">
          <div className="text-sm font-medium text-gray-500" data-id="element-507">Inactive</div>
          <div className="text-2xl font-bold mt-1" data-id="element-508">5</div>
          <div className="text-xs text-red-600 mt-1" data-id="element-509">3% of total</div>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow" data-id="element-510">
        <div className="flex flex-wrap gap-4 items-center" data-id="element-511">
          <div className="relative flex-grow max-w-md" data-id="element-512">
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-513" />
            <input type="text" placeholder="Search by name or ITS number..." className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-514" />
          </div>
          <button className="flex items-center space-x-1 px-3 py-2 border rounded-md hover:bg-gray-50" data-id="element-515">
            <FilterIcon size={18} data-id="element-516" />
            <span data-id="element-517">Filter</span>
          </button>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-518">
            <option data-id="element-519">All Statuses</option>
            <option data-id="element-520">Active</option>
            <option data-id="element-521">On Leave</option>
            <option data-id="element-522">Inactive</option>
          </select>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-523">
            <option data-id="element-524">All Ranks</option>
            <option data-id="element-525">Senior Guard</option>
            <option data-id="element-526">Guard Level 3</option>
            <option data-id="element-527">Guard Level 2</option>
            <option data-id="element-528">Guard Level 1</option>
          </select>
          <select className="px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-529">
            <option data-id="element-530">Sort By: Newest First</option>
            <option data-id="element-531">Sort By: Oldest First</option>
            <option data-id="element-532">Sort By: Name A-Z</option>
            <option data-id="element-533">Sort By: Name Z-A</option>
          </select>
        </div>
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-534">
        <div className="overflow-x-auto" data-id="element-535">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-536">
            <thead className="bg-gray-50" data-id="element-537">
              <tr data-id="element-538">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-539">
                  Member
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-540">
                  ITS Number
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-541">
                  Rank
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-542">
                  Join Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-543">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-544">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-545">
              {members.map(member => <tr key={member.id} className="hover:bg-gray-50" data-id="element-546">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-547">
                    <div className="flex items-center" data-id="element-548">
                      <div className="flex-shrink-0 h-10 w-10" data-id="element-549">
                        <img className="h-10 w-10 rounded-full object-cover" src={member.profileImage} alt={member.name} data-id="element-550" />
                      </div>
                      <div className="ml-4" data-id="element-551">
                        <div className="text-sm font-medium text-gray-900" data-id="element-552">
                          {member.name}
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-553">
                          {member.email}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-554">
                    <div className="text-sm text-gray-900" data-id="element-555">
                      {member.itsNumber}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-556">
                    <div className="text-sm text-gray-900" data-id="element-557">{member.rank}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-558">
                    <div className="text-sm text-gray-900" data-id="element-559">
                      {member.joinDate}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-560">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${member.status === 'Active' ? 'bg-green-100 text-green-800' : member.status === 'On Leave' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-561">
                      {member.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-562">
                    <button onClick={() => handleView(member)} className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-563">
                      View
                    </button>
                    <button onClick={() => handleEdit(member)} className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-564">
                      Edit
                    </button>
                    <button className="text-red-600 hover:text-red-900" data-id="element-565">
                      Deactivate
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t" data-id="element-566">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-567">
            <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-568">
              Previous
            </button>
            <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-569">
              Next
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-570">
            <div data-id="element-571">
              <p className="text-sm text-gray-700" data-id="element-572">
                Showing <span className="font-medium" data-id="element-573">1</span> to{' '}
                <span className="font-medium" data-id="element-574">8</span> of{' '}
                <span className="font-medium" data-id="element-575">140</span> members
              </p>
            </div>
            <div data-id="element-576">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-577">
                <button className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-578">
                  <span className="sr-only" data-id="element-579">Previous</span>
                  <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-580" />
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-blue-800 text-sm font-medium text-white" data-id="element-581">
                  1
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-582">
                  2
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-583">
                  3
                </button>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-584">
                  ...
                </span>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-585">
                  18
                </button>
                <button className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-586">
                  <span className="sr-only" data-id="element-587">Next</span>
                  <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-588" />
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* View Member Modal */}
      {showViewModal && selectedMember && <div className="fixed inset-0 overflow-y-auto z-50" data-id="element-589">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-590">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-591">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-592"></div>
            </div>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-593">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-594">
                <div className="flex justify-between items-center pb-3 border-b" data-id="element-595">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-596">
                    Member Details
                  </h3>
                  <button onClick={() => setShowViewModal(false)} className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-597">
                    <XIcon size={20} data-id="element-598" />
                  </button>
                </div>
                <div className="mt-4" data-id="element-599">
                  <div className="flex flex-col items-center mb-6" data-id="element-600">
                    <img src={selectedMember.profileImage} alt={selectedMember.name} className="w-24 h-24 rounded-full object-cover mb-2" data-id="element-601" />
                    <h2 className="text-xl font-bold" data-id="element-602">{selectedMember.name}</h2>
                    <div className="text-sm text-gray-500" data-id="element-603">
                      {selectedMember.itsNumber}
                    </div>
                    <span className={`mt-2 px-2 py-1 text-xs font-semibold rounded-full ${selectedMember.status === 'Active' ? 'bg-green-100 text-green-800' : selectedMember.status === 'On Leave' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-604">
                      {selectedMember.status}
                    </span>
                  </div>
                  <div className="space-y-4" data-id="element-605">
                    <div className="flex items-start" data-id="element-606">
                      <BadgeIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-607" />
                      <div data-id="element-608">
                        <div className="text-sm font-medium text-gray-500" data-id="element-609">
                          Rank
                        </div>
                        <div data-id="element-610">{selectedMember.rank}</div>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-611">
                      <PhoneIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-612" />
                      <div data-id="element-613">
                        <div className="text-sm font-medium text-gray-500" data-id="element-614">
                          Phone
                        </div>
                        <div data-id="element-615">{selectedMember.phone}</div>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-616">
                      <MailIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-617" />
                      <div data-id="element-618">
                        <div className="text-sm font-medium text-gray-500" data-id="element-619">
                          Email
                        </div>
                        <div data-id="element-620">{selectedMember.email}</div>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-621">
                      <MapPinIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-622" />
                      <div data-id="element-623">
                        <div className="text-sm font-medium text-gray-500" data-id="element-624">
                          Address
                        </div>
                        <div data-id="element-625">{selectedMember.address}</div>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-626">
                      <CalendarIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-627" />
                      <div data-id="element-628">
                        <div className="text-sm font-medium text-gray-500" data-id="element-629">
                          Join Date
                        </div>
                        <div data-id="element-630">{selectedMember.joinDate}</div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 pt-4 border-t" data-id="element-631">
                    <h4 className="font-medium mb-2" data-id="element-632">Recent Activities</h4>
                    <div className="space-y-2" data-id="element-633">
                      <div className="bg-gray-50 p-2 rounded text-sm" data-id="element-634">
                        <div className="font-medium" data-id="element-635">
                          Completed Duty: Ashara Security
                        </div>
                        <div className="text-gray-500" data-id="element-636">August 15, 2023</div>
                      </div>
                      <div className="bg-gray-50 p-2 rounded text-sm" data-id="element-637">
                        <div className="font-medium" data-id="element-638">
                          Lawajam Payment: ₹2,500
                        </div>
                        <div className="text-gray-500" data-id="element-639">August 10, 2023</div>
                      </div>
                      <div className="bg-gray-50 p-2 rounded text-sm" data-id="element-640">
                        <div className="font-medium" data-id="element-641">
                          Assigned to: Eid-ul-Fitr Duty
                        </div>
                        <div className="text-gray-500" data-id="element-642">August 5, 2023</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-643">
                <button type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-800 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm" onClick={() => {
              setShowViewModal(false);
              handleEdit(selectedMember);
            }} data-id="element-644">
                  Edit Member
                </button>
                <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm" onClick={() => setShowViewModal(false)} data-id="element-645">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Add/Edit Member Modal */}
      {showAddModal && <div className="fixed inset-0 overflow-y-auto z-50" data-id="element-646">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-647">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-648">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-649"></div>
            </div>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-650">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-651">
                <div className="flex justify-between items-center pb-3 border-b" data-id="element-652">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-653">
                    {selectedMember ? 'Edit Member' : 'Add New Member'}
                  </h3>
                  <button onClick={() => setShowAddModal(false)} className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-654">
                    <XIcon size={20} data-id="element-655" />
                  </button>
                </div>
                <div className="mt-4 space-y-4" data-id="element-656">
                  <div className="flex justify-center" data-id="element-657">
                    <div className="relative" data-id="element-658">
                      <img src={selectedMember?.profileImage || 'https://via.placeholder.com/100?text=Upload+Photo'} alt="Profile" className="w-24 h-24 rounded-full object-cover" data-id="element-659" />
                      <button className="absolute bottom-0 right-0 bg-blue-800 text-white p-1 rounded-full" data-id="element-660">
                        <PlusIcon size={16} data-id="element-661" />
                      </button>
                    </div>
                  </div>
                  <div data-id="element-662">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-663">
                      Full Name
                    </label>
                    <input type="text" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter full name" defaultValue={selectedMember?.name || ''} data-id="element-664" />
                  </div>
                  <div data-id="element-665">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-666">
                      ITS Number
                    </label>
                    <input type="text" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter ITS number" defaultValue={selectedMember?.itsNumber || ''} data-id="element-667" />
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-668">
                    <div data-id="element-669">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-670">
                        Rank
                      </label>
                      <select className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedMember?.rank || ''} data-id="element-671">
                        <option value="" disabled data-id="element-672">
                          Select Rank
                        </option>
                        <option data-id="element-673">Senior Guard</option>
                        <option data-id="element-674">Guard Level 3</option>
                        <option data-id="element-675">Guard Level 2</option>
                        <option data-id="element-676">Guard Level 1</option>
                      </select>
                    </div>
                    <div data-id="element-677">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-678">
                        Status
                      </label>
                      <select className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedMember?.status || 'Active'} data-id="element-679">
                        <option data-id="element-680">Active</option>
                        <option data-id="element-681">On Leave</option>
                        <option data-id="element-682">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div data-id="element-683">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-684">
                      Phone Number
                    </label>
                    <input type="tel" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone number" defaultValue={selectedMember?.phone || ''} data-id="element-685" />
                  </div>
                  <div data-id="element-686">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-687">
                      Email Address
                    </label>
                    <input type="email" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email address" defaultValue={selectedMember?.email || ''} data-id="element-688" />
                  </div>
                  <div data-id="element-689">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-690">
                      Address
                    </label>
                    <textarea className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" rows={2} placeholder="Enter address" defaultValue={selectedMember?.address || ''} data-id="element-691"></textarea>
                  </div>
                  <div data-id="element-692">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-693">
                      Join Date
                    </label>
                    <input type="date" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={selectedMember?.joinDate || new Date().toISOString().split('T')[0]} data-id="element-694" />
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-695">
                <button type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-800 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm" onClick={() => setShowAddModal(false)} data-id="element-696">
                  {selectedMember ? 'Update Member' : 'Add Member'}
                </button>
                <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:w-auto sm:text-sm" onClick={() => setShowAddModal(false)} data-id="element-697">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default MemberManagementScreen;